import React from 'react';

export function InputModal({error, type, placeholder = '', name, title, value, disabled, onChange, className = ''}) {

  return <div className={"modal__group" + (className ? ' ' + className : '')}>
    <p className="modal__help">{title}</p>
    {type === 'textarea' && <textarea name={name}
                                      className={"input" + (error ? " input--error" : "")}
                                      placeholder={placeholder}
                                      value={value}
                                      disabled={disabled}
                                      onChange={onChange}></textarea>}
    {type !== 'textarea' && <input type={type}
                                   name={name}
                                   className={"input" + (error ? " input--error" : "")}
                                   placeholder={placeholder}
                                   value={value}
                                   disabled={disabled}
                                   onChange={onChange}/>}
  </div>;
}
